import {post} from '../utils'

export default host => () => post(`${host}/user/activeFreePlan`)